import { put, takeEvery } from 'redux-saga/effects';
import {
  fetchUsersSuccess,
  fetchUsersFailure,
} from 'redux/ums-user-management/actions';
import request from 'utils/request';
import urls from 'utils/config';
import UmsUserManagementActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

export function* fetchUsers({ payload }) {
  const { limit, offset, keyword, roleId, blocked } = payload;
  const url = `${API_BASE_URL}/ums/users?limit=${limit}&offset=${offset}${
    keyword ? `&keyword=${keyword}` : ''
  }${roleId ? `&roleId=${roleId}` : ''}${
    blocked
      ? `&blocked=${blocked.toLowerCase() === 'active' ? false : true}`
      : ''
  }`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchUsersSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Users: ${response.message}`);
    yield put(fetchUsersFailure(response.message));
  }
}

export function* onFetchUsers() {
  yield takeEvery(
    UmsUserManagementActionTypes.FETCH_UMS_USERS_START,
    fetchUsers
  );
}
